﻿export class request_payment {
    public client_booking_id: string | null = null;
    public amount: number | null = null;
    public gross_amount: number | null = null;
    public fee: number | null = null;
    public commission: number | null = null;
    public tour_id: string | null = null;
}